import { render, staticRenderFns } from "./usersettings.vue?vue&type=template&id=0754f490&scoped=true"
import script from "./usersettings.vue?vue&type=script&lang=js"
export * from "./usersettings.vue?vue&type=script&lang=js"
import style0 from "./usersettings.vue?vue&type=style&index=0&id=0754f490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754f490",
  null
  
)

export default component.exports